// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__-kzAC","dialog":"Dialog_dialog__2Nku2","contentArea":"Dialog_contentArea__2eLec","buttons":"Dialog_buttons__3mide"};